<template>
    <q-video
        :src="url"
        style="border-radius: 12px; margin-left: 15px; margin-right: 15px"
        :ratio="16/9"
    />
</template>

<script>
import uiControlMixin from 'src/mixins/ui/uiControlMixin';

export default {
    name: 'Video',
    mixins: [uiControlMixin],
    computed: {
        url () {
            return this.params.url;
        },
    },
};
</script>

<style scoped>

</style>
